<button
  class="common-selector flex flex--column flex--left-center grow fill ps-medium white-bg focus-inset link-hover align-left"
  [class.separator-padding]="separatorPadding"
  [ngClass]="paddingStyle[separatorPadding]"
  type="button"
  [attr.aria-label]="ariaLabel"
  [attr.aria-disabled]="disabled"
>
  <span class="regular-type font-body-1 grey-600-text" data-test-common-selector-label>{{ label }}</span>
  <div
    class="flex flex--space-between fill medium-type font-body-1 nordic-blue-900-text common-selector-text"
    data-test-common-selector-text
  >
    <ng-content></ng-content>
  </div>
</button>
